/* eslint-disable import/no-duplicates */
import { format } from 'date-fns';
import ptBr from 'date-fns/locale/pt-BR';
import { useState } from 'react';
import {
  Flex,
  Modal,
  Button,
  ModalCloseButton,
  ModalContent,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@grupoboticario/flora-react';
import { MdTimeline, MdOutlineDescription } from 'react-icons/md';
import { STATUS_OBJ } from 'utils/statusEnum';
import { claimTypeOptions, claimDaysInactive } from 'utils/claimTypeOptions';
import { StatusTag, DaysTag } from 'components/styled/StatusTag';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { useDispatch } from 'react-redux';
import { deleteDraftAction } from 'store/modules/claims/actions';
import {
  Container,
  MainContent,
  Title,
  Header,
  MainText,
  Label,
  ActionButton,
  Footer,
  ModalText,
  MainTags,
  TagsHeader,
} from './styles';
import { ClaimType, Props } from './types';

export function ClaimCard({
  id,
  title,
  storeName,
  type,
  storeNumber,
  status,
  comunicationDate,
  onClickTimeline,
  onClickProccess,
  claimWithoutUpdate,
}: Readonly<Props>) {
  const [modalOpen, setModalOpen] = useState(false);
  const history = useHistoryWithHost();
  const dispatch = useDispatch();

  if (!id) {
    return <Container status="Clean" />;
  }

  const claimType: ClaimType = {
    ...claimTypeOptions,
    [STATUS_OBJ.Draft]: {
      buttons: (
        <>
          <ActionButton
            onClick={() => history.push(`/openclaim/${id}`)}
            styleSemantic="neutral"
            hierarchy="secondary"
          >
            Continuar
          </ActionButton>
          <ActionButton
            className="warning-ghost"
            styleSemantic="warning"
            onClick={() => setModalOpen(true)}
          >
            Excluir
          </ActionButton>
        </>
      ),
    },
  };
  const claim = claimType[status];

  const daysInactive = claimDaysInactive[claimWithoutUpdate];

  async function deleteDraft() {
    dispatch(deleteDraftAction(id));
    setModalOpen(false);
  }

  const hasDaysTag = daysInactive?.days;
  const hasStatusTag = claim?.value;

  const hasDaysAndStatus = hasDaysTag && hasStatusTag;

  return (
    <>
      <Container status={status}>
        <TagsHeader hasTwoChildren={hasDaysAndStatus}>
          <MainTags hasTwoChildren={hasDaysAndStatus}>
            {hasDaysTag && (
              <DaysTag color={daysInactive.color} shape="ghost">
                {daysInactive.days}
              </DaysTag>
            )}

            {hasStatusTag && (
              <StatusTag variant={claim.tagType}>{claim.value}</StatusTag>
            )}
          </MainTags>
        </TagsHeader>
        <Header>
          <Title>
            {status !== STATUS_OBJ.Draft ? 'Sinistro' : 'Rascunho'}
            &nbsp;
            {title}
          </Title>
        </Header>
        <main>
          <MainContent>
            <Label>Loja</Label>
            <MainText>{`${storeNumber} - ${storeName}`}</MainText>
          </MainContent>
          <MainContent>
            <Flex justify="space-between">
              <Flex direction="column" id="claim-type">
                <Label>Tipo de Sinistro</Label>
                <MainText>{type}</MainText>
              </Flex>
              <Flex direction="column">
                <Label>
                  {status !== STATUS_OBJ.Draft ? 'Comunicado em:' : 'Salvo em:'}
                </Label>
                <MainText>
                  {format(new Date(comunicationDate), 'dd MMM yyyy', {
                    locale: ptBr,
                  })}
                </MainText>
              </Flex>
            </Flex>
          </MainContent>
        </main>
        <Footer>
          {claim?.buttons ? (
            claim?.buttons
          ) : (
            <>
              <ActionButton
                size="small"
                has="iconRight"
                icon={<MdTimeline size={22} />}
                onClick={onClickTimeline}
              >
                Ver
              </ActionButton>
              <ActionButton
                size="small"
                has="iconRight"
                icon={<MdOutlineDescription size={20} />}
                hierarchy="secondary"
                styleSemantic="neutral"
                onClick={onClickProccess}
              >
                Resumo
              </ActionButton>
            </>
          )}
        </Footer>
      </Container>
      <Modal open={modalOpen} onOpenChange={setModalOpen}>
        <ModalContent size="small">
          <ModalCloseButton />
          <ModalHeader />
          <ModalBody>
            <ModalText>Deseja excluir este rascunho?</ModalText>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => deleteDraft()}>Sim</Button>
            <Button styleSemantic="warning" onClick={() => setModalOpen(false)}>
              Não
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
